"use client";

import { useEffect, useState } from "react";
import Image from "next/image";
import { X } from "lucide-react";

import { AppAssets } from "@/lib/assets";

const SESSION_KEY = "borneo_ad_home_v1";

interface AdCenterModalProps {
  src?: string;
  href?: string;
}

/** Popup A — center card modal, 1× per sesi. */
export function AdCenterModal({ src = AppAssets.promoBanner, href }: AdCenterModalProps) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (!sessionStorage.getItem(SESSION_KEY)) {
        sessionStorage.setItem(SESSION_KEY, "1");
        setOpen(true);
      }
    } catch {
      // private mode / blocked storage — skip
    }
  }, []);

  if (!open) return null;

  const inner = (
    <div
      className="relative w-full max-w-sm overflow-hidden rounded-2xl"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={() => setOpen(false)}
        aria-label="Tutup iklan"
        className="absolute right-3 top-3 z-10 grid size-7 place-items-center rounded-full bg-black/50 text-white transition-opacity hover:opacity-80"
      >
        <X className="size-4" aria-hidden />
      </button>
      <div className="relative aspect-[4/3]">
        <Image
          src={src}
          alt="Iklan sponsor"
          fill
          sizes="384px"
          className="object-cover"
        />
      </div>
      <p className="bg-black/70 py-1.5 text-center font-label text-label-caps text-[10px] uppercase tracking-widest text-white/50">
        Sponsor
      </p>
    </div>
  );

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-6"
      onClick={() => setOpen(false)}
    >
      {href ? (
        <a href={href} target="_blank" rel="noopener noreferrer">
          {inner}
        </a>
      ) : (
        inner
      )}
    </div>
  );
}
